import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { secToHmsFilter } from '@filters/sec-to-hms';
import { isNumber } from '@tools/type-guards';

import CardLoadable from '@components/Cards/CardLoadable.vue';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    CardFlightTime: ComponentWithProps<Props>;
  }
}

/**
 * `CardFlightTime` component properties.
 */
export interface Props {
  loading: boolean;
  value?: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardFlightTime',
  props: {
    loading: { type: Boolean },
    value: null
  },
  setup(__props: any) {

const props = __props as {
  loading: boolean;
  value?: number | null;
};



const flightTime = computed(() => {
  return isNumber(props.value) ? secToHmsFilter(props.value) : 'N/A';
});

return { __sfc: true,props, flightTime, CardLoadable }
}

})